/* eslint-disable */
import React, { Suspense } from 'react';
import ReactGA from 'react-ga';
import { HashRouter } from 'react-router-dom';
import CacheBuster from 'react-cache-buster';
import CssBaseline from '@material-ui/core/CssBaseline';
import { StylesProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';

import TaskProvider from './contexts/taskContext';
import UserProvider from './contexts/UserContext';
import './Global.style.css';
import AjaxInterceptors from './utils/AjaxInterceptors';
import ScrollToTop from './ScrollToTop';
import Loader from './components/Loader/Loader';
import NetworkProvider from './contexts/networkContext';
import { version } from '../package.json';
import AppRoute from './routes/index';

ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID);

function App() {
  /* const userCookie = Cookies.get('user');
  const userTokenCookie = Cookies.get('token');
  if (!userCookie || !userTokenCookie) {
    location.reload();
  }
  Cookies.set(
    'token',
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IjEifQ.eyJkYXRhIjoiNWYyZDI2MmI5YTVhZDAzYTI5NDc4MDk1IiwiaWF0IjoxNjQ3ODIyODgyLCJhdWQiOiI1ZjJkMjYyYjlhNWFkMDNhMjk0NzgwOTUiLCJpc3MiOiI1ZjJkMjYyYjlhNWFkMDNhMjk0NzgwOTUiLCJzdWIiOiJ1c2VyIiwianRpIjoiMSJ9.bO-2r98Fl3hlxA8KiEAkdOjdxmUsERxn6aQTjZWnh-c',
    { expires: 7 },
  );
  Cookies.set(
    'user',
    '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',
    { expires: 7 },
  ); */
  // const classes = useStyles();

  return (
    <StylesProvider injectFirst>
      <CacheBuster
        currentVersion={version}
        isEnabled={true} //If false, the library is disabled.
        isVerboseMode={false} //If true, the library writes verbose logs to console.
        loadingComponent={<Loader />} //If not pass, nothing appears at the time of new version check.
        metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server.
      >
        {' '}
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <HashRouter>
            <ScrollToTop />
            <CssBaseline />
            <Suspense fallback={<Loader />}>
              <NetworkProvider>
                <TaskProvider>
                  <UserProvider>
                    <>
                      <AjaxInterceptors />
                      <AppRoute />
                    </>
                  </UserProvider>
                </TaskProvider>
              </NetworkProvider>
            </Suspense>
          </HashRouter>
        </MuiPickersUtilsProvider>
      </CacheBuster>
    </StylesProvider>
  );
}

export default App;
